"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immutable_1 = require("immutable");
const Node_1 = require("./Node");
function generateOperator(value) {
    return (...children) => new Node_1.Operator(value, immutable_1.List(children));
}
exports.generateOperator = generateOperator;
exports.plus = generateOperator(Node_1.OperatorSymbol.Plus);
exports.minus = generateOperator(Node_1.OperatorSymbol.Minus);
exports.mul = generateOperator(Node_1.OperatorSymbol.Mul);
exports.div = generateOperator(Node_1.OperatorSymbol.Div);
exports.pow = generateOperator(Node_1.OperatorSymbol.Pow);
exports.depends = generateOperator(Node_1.OperatorSymbol.Depends);
exports.constant = generateOperator(Node_1.OperatorSymbol.Constant);
exports.not = generateOperator(Node_1.OperatorSymbol.Not);
exports.and = generateOperator(Node_1.OperatorSymbol.And);
exports.or = generateOperator(Node_1.OperatorSymbol.Or);
exports.flag = generateOperator(Node_1.OperatorSymbol.Flag);
exports.equals = generateOperator(Node_1.OperatorSymbol.Equals);
//# sourceMappingURL=utils.js.map